/**
 * This feature's routes, as constants.
 *
 * Separate from `routes.tsx` so a screen can link to another screen without
 * importing the module that builds the route table — which would be a cycle,
 * since the table imports the screens.
 */

export const INTEGRATION_PATHS = {
  sync: "/integration/synchronisation",
  connector: "/integration/connecteur",
  mapping: "/integration/mapping",
  entityMapping: "/integration/mapping/$entity",
} as const;
